import { SET_INDUSTRY, GO_BACK, GO_TO_TAGS_SELECTOR, SKIP_AND_GO_TO_TAGS_SELECTOR } from '../mainActionTypes';
// import { biLog } from '../services/biService';
// import { goToTagsSelector } from './navigationActions';
// import { setLogoListSearch } from './logoListActions';

export function setIndustry(industry, industryText, isCustom) {
  return {
    type: SET_INDUSTRY,
    payload: { industry, industryText, isCustom }
  };
}

export function setLogoListSearchAndGoToTagsSelector() {
  let action = {};
  action = {
    type: GO_TO_TAGS_SELECTOR
  };
  return action;
};

export const skipIndustryPage = () => {
  let action = {};
  action = {
    type: SKIP_AND_GO_TO_TAGS_SELECTOR
  };
  return action;
};

export function goBack() {
  return {
    type: GO_BACK
  };
}
